function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.30752 9.11565C5.30752 6.47747 6.67426 5.11194 9.27107 5.11194H17.4533V4.8797C17.4533 2.96609 16.4875 2 14.5923 2H4.86105C2.94761 2 2 2.96609 2 4.8797V14.6521C2 16.575 2.94761 17.5318 4.86105 17.5318H5.30752V9.11565ZM9.40775 22H19.139C21.0433 22 22 21.0432 22 19.1296V9.25499C22 7.34138 21.0433 6.37529 19.139 6.37529H9.40775C7.50342 6.37529 6.5467 7.34138 6.5467 9.25499V19.1296C6.5467 21.0432 7.50342 22 9.40775 22Z",
  fill: "#BFBBCF"
});

function SvgIconVersions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVersions);
export default __webpack_public_path__ + "static/media/icon-versions.1d5d5edf.svg";
export { ForwardRef as ReactComponent };